import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyDi_D1lc7jjssfmlVDdWTu6E3Cmkk3Yr_4', // old api key. didn't work cause no billing set on g.account
    key: "AIzaSyAQx_58Js6G4kf3HNDibMcqZUy2xeGv-TA",
    libraries: "places",
  },
});
